export function matchPathname(matcher: string, pathname: string): boolean {
  try {
    const pattern = matcher.replace(/\*/g, ".*");
    const regex = new RegExp(`^${pattern}$`);
    return regex.test(pathname);
  } catch {
    return false;
  }
}
